import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';
import { NavigationOptions } from '../shared/model/navigation-options.model';
import { Constants } from '../constants/constants';
import { AuthenticationService } from '../service/authentication.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  accountCategory: string;
  accountType: string;
  updateAccount: boolean = false;

  navigationOptions: Array<NavigationOptions> = [];

  constructor(private apiService: ApiService, public authService: AuthenticationService) { }

  ngOnInit() {
    if(!this.authService.isDongleProvider()) {
      this.accountCategory = this.apiService.accountDetail.category;
      this.accountType = this.apiService.accountDetail.type;
    }
    this.initNavigationOptions();
  }

  initNavigationOptions() {
    this.navigationOptions = [];
    this.navigationOptions.push(new NavigationOptions("Company Profile", "assets/images/user.png", "Company Profile", "#companyProfile", "Manage company profile settings"));
  }

  updateAccountClicked() {
    this.updateAccount = true;
  }

  cancelUpdate() {
    this.updateAccount = false;
  }

}
